module.exports = __webpack_public_path__ + "media/application/images/2018/anchor-heading-dropdown-213310e9aa0cf1d5ce78ba1f537c595e.svg";